module.exports = __webpack_public_path__ + "img/cloud.858412d.svg";